// extracted by mini-css-extract-plugin
export var webhotSwiper = "index-module--webhotSwiper--04wy-";